import { useContext, useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';
import StepHeader from '../../components/Wizard/StepHeader';
import { useNavigate } from 'react-router-dom';
import Separator from '../../components/Separator';
import ButtonGoogle from '../../components/SocialMedia/ButtonGoogle';
import ButtonMicrosoft from '../../components/SocialMedia/ButtonMicrosoft';
import ButtonApple from '../../components/SocialMedia/ButtonApple';
import { SocialEnum } from '../../enums/SocialEnum';
import { getEmailProvider } from '../../utils/string';

export interface CodeNotarriveProps {
  label: string;
  context: any;
}

export default function CodeNotArrive({ label, context }: CodeNotarriveProps) {
  const [provider, setProvider] = useState<SocialEnum | null>(null);

  const { originDomainForm, getValues } = useContext<any>(context);
  const navigate = useNavigate();

  function backPage() {
    navigate(
      originDomainForm === 'signup'
        ? '/signin'
        : originDomainForm === 'sbt/signup'
          ? '/sbt/signin'
          : '/sbt/signin'
    );
  }

  useEffect(() => {
    setProvider(getEmailProvider(getValues('email')));
  }, []);

  return (
    <>
      <div className="card__section">
        <div className="card__top">
          <StepHeader
            title="Não foi dessa vez"
            description={[
              `Não conseguimos enviar um código para seu ${label} neste momento.`,
              'Por favor, tente novamente mais tarde.'
            ]}
          />

          <Separator text="ou" />

          {provider === SocialEnum.GOOGLE ? (
            <ButtonGoogle showText />
          ) : provider === SocialEnum.MICROSOFT ? (
            <ButtonMicrosoft showText />
          ) : (
            <ButtonApple showText />
          )}
        </div>

        <div className="button-group">
          <Button customColors="btn-ghost" full onClick={backPage}>
            <ButtonLabel>voltar ao início</ButtonLabel>
          </Button>
        </div>
      </div>
    </>
  );
}
